import * as React from 'react';
import {
  FIND_ONBOARDING_PAGE,
  FIND_PAGE,
  HOME_PAGE_REWRITE,
  MY_ACTIVITY_PAGE,
  MY_YOU_PAGE,
  PLAYER_CHATS_PAGE,
  ROOT_PAGE,
  getFindPageUrl,
} from 'constants/pages';
import { useFindPlayersOnboarding } from 'hooks/useFindPlayersOnboarding';
import PlusWithoutBG from 'svg/PlusWithoutBG';
import { FindTab } from 'screens/Find/types';
import { Button } from 'components/Button';
import NavLink from './NavLink';

interface Props {
  currentPath: string;
  currentPathname: string;
  isInvert?: boolean;
  onOpenEventTypeModal: () => void;
  onNavigate: (href: string) => void;
}

export default function PlayerNavLinks({
  currentPath,
  currentPathname,
  isInvert,
  onOpenEventTypeModal,
  onNavigate,
}: Props) {
  const { hasCompletedOnboarding } = useFindPlayersOnboarding();

  const isHomeActive = currentPath === ROOT_PAGE || currentPath.startsWith(HOME_PAGE_REWRITE);
  // Sub-pages (/you/skills, /you/favorites, …) keep the tab lit.
  const isYouActive = currentPath === MY_YOU_PAGE || currentPath.startsWith(`${MY_YOU_PAGE}/`);
  // pathname, not asPath: /find always carries a ?tab= param.
  const isFindActive = currentPathname === FIND_PAGE || currentPathname === FIND_ONBOARDING_PAGE;
  // pathname, not asPath: the tab rides in a ?tab= param, and from lg up a chat thread
  // opens inside the activity page.
  const isActivityActive =
    currentPathname === MY_ACTIVITY_PAGE || currentPathname.startsWith(`${PLAYER_CHATS_PAGE}/`);

  return (
    <div className="mx-3 hidden h-full items-center xs:gap-0 md:flex lg:gap-3">
      <NavLink href={ROOT_PAGE} isActive={isHomeActive} isInvert={isInvert} onNavigate={onNavigate}>
        Home
      </NavLink>
      <NavLink
        href={hasCompletedOnboarding ? getFindPageUrl(FindTab.Players) : FIND_ONBOARDING_PAGE}
        isActive={isFindActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Players
      </NavLink>
      <div className="px-ds-lg py-2">
        <Button
          variant="brand"
          className="flex h-10 w-10 shrink-0 grow-0 rounded-full border-none px-2.5 shadow-lg focus:outline-none"
          onClick={onOpenEventTypeModal}
          iconLeft={<PlusWithoutBG className="h-6 w-6 cursor-pointer" />}
          size="icon"
        />
      </div>
      <NavLink
        href={MY_ACTIVITY_PAGE}
        isActive={isActivityActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        Activity
      </NavLink>
      <NavLink
        href={MY_YOU_PAGE}
        isActive={isYouActive}
        isInvert={isInvert}
        onNavigate={onNavigate}
      >
        You
      </NavLink>
    </div>
  );
}
